import React from 'react';
import { ApolloProvider, useQuery } from '@apollo/client';
import { IntlProvider, useIntl } from 'react-intl';
import gql from 'graphql-tag';
import client from '../../../../lib/apolloClient';
import translations from '../../../../lib/i18n/translations.json';
import SuccessionCfaStart from '../components/start/SuccessionCfaStart';

const GET_SUCCESSION_CFA_START_DATA = gql`
  query GetSuccessionCfaStartData {
    getCurrentUser {
      id
      name
      email
      gross_production
      company {
        id
        name
        display_name
        host
        cash_flow_analysis_word
        cash_flow_analysis_word_fr
        features
      }
    }
  }
`;

const SuccessionCfaStartInner = () => {
  const intl = useIntl();
  const { loading, error, data } = useQuery(GET_SUCCESSION_CFA_START_DATA);

  if (loading) return <div className="flex items-center justify-center min-h-screen bg-[var(--succession-bg-secondary)]"><div className="animate-spin rounded-full h-12 w-12 border-b-2 border-succession-primary"></div></div>;
  if (error) return <div className="flex items-center justify-center min-h-screen bg-[var(--succession-bg-secondary)] text-[var(--succession-error)]">{intl.formatMessage({ id: 'succession.cash_flow_analysis.container.error_loading' })}</div>;
  return <SuccessionCfaStart currentUser={data.getCurrentUser} />;
};

const SuccessionCfaStartContainer = (props, railsContext) => {
  window.locale = (railsContext && railsContext.i18nLocale) || window.locale || 'en';
  const locale = window.locale;
  
  return (
    <ApolloProvider client={client}>
      <IntlProvider locale={locale} messages={translations[locale] || translations.en}>
        <SuccessionCfaStartInner />
      </IntlProvider>
    </ApolloProvider>
  );
};

export default SuccessionCfaStartContainer; 